import type {TypedRoute} from '@typed-router';
import type {RouteLocationNormalizedLoaded} from 'vue-router';
import {useGuestHost} from '#imports';

export function useExtractQueryParameters(route: RouteLocationNormalizedLoaded | TypedRoute): string {
    let searchParams = buildURL(useGuestHost(), route.fullPath).search;
    if (searchParams.startsWith('?')) {
        searchParams = searchParams.substring(1);
    }

    return searchParams;
}

export function useExtractQueryParametersAsSearchParams(route: RouteLocationNormalizedLoaded | TypedRoute): URLSearchParams {
    return buildURL(useGuestHost(), route.fullPath).searchParams;
}

function buildURL(host: string, fullPath: string): URL {
    const normalizedHost = host.endsWith('/') ? host.slice(0, -1) : host;
    const normalizedPath = fullPath.startsWith('/') ? fullPath : `/${fullPath}`;
    return new URL(`${normalizedHost}${normalizedPath}`);
}
